import { motion, AnimatePresence } from "framer-motion";
import { X, Instagram, Facebook, ArrowUpRight } from "lucide-react";
import { SOCIAL_LINKS } from "@/data/content";

const ICONS = { Instagram: Instagram, Facebook: Facebook };

const SocialModal = ({ open, onClose }) => (
  <AnimatePresence>
    {open && (
      <motion.div
        className="fixed inset-0 z-[100] flex items-center justify-center p-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className="absolute inset-0 bg-corp-700/70 backdrop-blur-sm" onClick={onClose} />
        <motion.div
          initial={{ opacity: 0, scale: 0.92, y: 24 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.95, y: 12 }}
          transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
          className="relative w-full max-w-md border border-[#123C6B]/10 bg-white p-10 shadow-[0_40px_120px_rgba(11,33,58,0.35)]"
          data-testid="farmers-social-modal"
        >
          <button
            onClick={onClose}
            data-testid="social-modal-close"
            aria-label="Close"
            className="absolute right-5 top-5 text-sage transition-colors hover:text-foreground"
          >
            <X className="h-5 w-5" />
          </button>
          <p className="flex items-center gap-3 font-mono text-xs uppercase tracking-[0.3em] text-corp-500">
            <span className="inline-block h-px w-8 bg-corp-500" /> Life With Farmers
          </p>
          <h3 className="mt-4 font-display text-3xl font-bold tracking-tight text-foreground">
            Watch our fields. Hear our farmers.
          </h3>
          <p className="mt-3 text-sm leading-relaxed text-mist">
            Follow Seed Park online for field performance videos, farmer reviews and harvest pictures.
          </p>
          <div className="mt-8 space-y-3">
            {SOCIAL_LINKS.map((s) => {
              const Icon = ICONS[s.platform];
              return (
                <div
                  key={s.platform}
                  data-testid={`social-row-${s.platform.toLowerCase()}`}
                  className="flex items-center justify-between border border-[#123C6B]/10 bg-forest-900 px-5 py-4"
                >
                  <div className="flex items-center gap-4">
                    <span className="flex h-10 w-10 items-center justify-center bg-brand-400 text-white">
                      <Icon className="h-5 w-5" />
                    </span>
                    <div>
                      <p className="font-display text-base font-bold text-foreground">{s.platform}</p>
                      <p className="text-xs text-sage">{s.note}</p>
                    </div>
                  </div>
                  <a
                    href={s.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`social-link-${s.platform.toLowerCase()}`}
                    className="group flex items-center gap-1 text-xs font-bold text-brand-400"
                  >
                    Click here
                    <ArrowUpRight className="h-3.5 w-3.5 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </a>
                </div>
              );
            })}
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
);

export default SocialModal;
